import { Box, Typography } from '@mui/material';
import { AI_GRADIENT_STOPS } from 'common/constants/ai';
import AISuggestionPopover from 'pages/Documents/components/SuggestedDocumentReference/AISuggestionPopover';
import { AISuggestionChipProps } from './AISuggestionChip.props';
import {
  chipContainerSx,
  commentaryItemSx,
  commentaryListSx,
  labelTypographySx,
  rectStyle,
  svgStyle,
} from './AISuggestionChip.styles';

const AISuggestionChip = ({
  label,
  value,
  commentary,
  confidence,
  onAccept,
  onDecline,
}: AISuggestionChipProps) => {
  const gradientId = `ai-gradient-chip-${value}`;

  const expandedContent = (
    <>
      {/* Mapped to */}
      <Box>
        <Typography variant="caption" color="text.secondary" fontWeight={500}>
          Mapped to
        </Typography>
        <Typography variant="body1" fontWeight={500}>
          {label}
        </Typography>
      </Box>

      {/* Why this suggestion */}
      {commentary && commentary.length > 0 && (
        <Box>
          <Typography variant="caption" color="text.secondary" fontWeight={500}>
            Why this suggestion?
          </Typography>
          <Box component="ul" sx={commentaryListSx}>
            {commentary.map((note, index) => (
              <Typography
                key={index}
                component="li"
                variant="body2"
                color="text.secondary"
                sx={commentaryItemSx}
              >
                {note}
              </Typography>
            ))}
          </Box>
        </Box>
      )}

      {/* Confidence */}
      {confidence != null && (
        <Box>
          <Typography variant="caption" color="text.secondary">
            Confidence: {Math.round(confidence * 100)}%
          </Typography>
        </Box>
      )}
    </>
  );

  return (
    <AISuggestionPopover
      documentReferenceId={value}
      title="AI Suggested Mapping"
      subtitle="Review and accept this suggestion"
      expandedContent={expandedContent}
      acceptLabel="Accept"
      onAccept={onAccept}
      onDecline={onDecline ?? (() => {})}
    >
      {({ onMouseEnter, onMouseLeave, ariaDescribedBy }) => (
        <Box
          aria-describedby={ariaDescribedBy}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          sx={chipContainerSx}
        >
          <svg style={svgStyle}>
            <defs>
              <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
                {AI_GRADIENT_STOPS.map(stop => (
                  <stop key={stop.offset} offset={stop.offset} stopColor={stop.color} />
                ))}
              </linearGradient>
            </defs>
            <rect
              x="1"
              y="1"
              rx="12"
              ry="12"
              fill="none"
              stroke={`url(#${gradientId})`}
              strokeWidth="2"
              strokeDasharray="6 4"
              style={rectStyle}
            />
          </svg>
          <Typography variant="body2" sx={labelTypographySx}>
            {label}
          </Typography>
        </Box>
      )}
    </AISuggestionPopover>
  );
};

export default AISuggestionChip;
